import { Reveal, Overline } from "@/components/Reveal";
import { BrandMarquee } from "@/components/Marquee";
import { BRANDS } from "@/data/content";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useConfig } from "@/context/ConfigContext";
import { waLink } from "@/config/site";
import { ArrowUpRight } from "lucide-react";

export default function Brands() {
  const cfg = useConfig();
  usePageMeta(
    "Brands You Can Trust | Chhannulal & Brothers (CLB)",
    "CLB stocks Nerolac, Dulux, Indigo, JK Paints, Supreme Pipes, Vectus, Gangotri Tanks, Somany Bathware, Cubix, Bathberry, Jim Sinks, Pidilite Dr. Fixit and the JK finishing range."
  );
  return (
    <main>
      <section className="bg-darknavy pb-20 pt-36 text-cream lg:pb-28 lg:pt-44" data-testid="brands-hero">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <Overline dark>Our brand partners</Overline>
            <h1 className="mt-4 font-display text-4xl font-light tracking-tight sm:text-6xl">Brands You Can Trust</h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-cream/70">
              Every brand on our shelves is one we'd put our own name behind. Explore the range — and ask us which product fits your project.
            </p>
          </Reveal>
        </div>
      </section>
      <BrandMarquee />
      <section className="bg-cream py-20 lg:py-28" data-testid="brands-grid">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid grid-cols-2 gap-px border border-darknavy/10 bg-darknavy/10 sm:grid-cols-3 lg:grid-cols-4">
            {BRANDS.map((b, i) => (
              <Reveal key={b.name} delay={(i % 4) * 0.06} className="bg-cream">
                <a
                  href={waLink(cfg, `Hello Chhannulal & Brothers, I would like to enquire about ${b.name} products.`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`brand-tile-${b.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group flex h-36 flex-col items-center justify-center px-4 text-center transition-colors duration-500 hover:bg-white"
                >
                  <span className="font-display text-lg font-semibold tracking-wide text-navy transition-colors duration-300 group-hover:text-aqua sm:text-xl">{b.name}</span>
                  <span className="mt-1.5 text-[10px] uppercase tracking-[0.2em] text-darknavy/40">{b.category}</span>
                  <span className="mt-3 inline-flex items-center gap-1 font-display text-[10px] font-semibold uppercase tracking-[0.2em] text-darknavy/30 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    Enquire <ArrowUpRight className="h-3 w-3" />
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <p className="mt-10 max-w-xl text-sm leading-relaxed text-darknavy/50">
              Official brand logos can be uploaded from the admin configuration area once available. Tiles above link straight to a WhatsApp enquiry for that brand.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
